import React from "react";
import { Navigate } from "react-router-dom";
import { CashRegisterPanel } from "../../../components/Admin/CashRegister";
import { usePermissions } from "../../../hooks";

export function CashRegisterPage() {
  const { hasPermission } = usePermissions();

  if (!hasPermission("paymentCategory", "read")) {
    return <Navigate to="/admin" replace />;
  }

  return <CashRegisterPanel />;
}
export default CashRegisterPage;
